module.exports = __webpack_public_path__ + "img/01.a1e97eed.png";